module.exports = __webpack_public_path__ + "img/imgrioc.048de1c2.png";